import styles from './styles.module.scss'
import PromocodeApplier from './PromocodeApplier'

export default function DiscountControl () {
  return (
    <div className={styles.root}>
      <div className={styles.promo}>
        <PromocodeApplier />
      </div>
    </div>
  )
}
